import { render } from "./ProjectGrid.vue?vue&type=template&id=21005704"
import script from "./ProjectGrid.vue?vue&type=script&lang=js"
export * from "./ProjectGrid.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__